/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
// import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'

import { Grid, FormControl, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { SiMicrosoftexcel } from 'react-icons/si';
import styles from './BudgetExceededReport.module.css'
import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField
} from '../FormComponents'
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex
} from '../../constants'

import Truckloading from "../../components/CvLoader/Cvloader";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { Button, CustomTab } from "../../atomicComponents";
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';
import apiService from '../../apis/apiService';
import { sanitizeNumeric } from '../../utils/utils';


function BudgetExceededReport() {
  const auth = useSelector((state) => state.auth); // useSelector
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const { showPopup } = usePopupManager();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const availableRoles = Array.isArray(auth?.userRole)
    ? auth.userRole
    : [];

  const [selectedRole, setSelectedRole] = useState("");
  const restrictedRoles = ["LI", "DS", "SA"];

  const restrictedRoleCount = availableRoles.filter(role =>
    restrictedRoles.includes(role)
  ).length;

  const disableExport =
    restrictedRoleCount > 1 && !selectedRole;
  const baseDefaultColumns = [
    { title: 'BC Number', field: 'bc_number' },
    { title: 'BC Name', field: 'bc_name' },
    { title: 'Employee No', field: 'employee_no' },
    { title: 'Employee Name', field: 'employee_name' },
    { title: 'Grade Group', field: 'grade_group' },
    { title: 'Manager ID', field: 'manager_id' },
    { title: 'Manager Name', field: 'manager_name' },
    { title: 'Project Code', field: 'project_definition' },
    { title: 'Project Code Desc', field: 'project_description' },
    { title: 'BU', field: 'bu' },
    { title: 'SUB BU', field: 'sub_bu' },
    { title: 'Vehicle Type', field: 'vehicle_type' },
    { title: 'Vehicle Family', field: 'vehicle_family' },
    { title: 'Gate', field: 'gate' },
    { title: 'MFL', field: 'mfl' },
    { title: 'Booking Date', field: 'booking_date' },
    { title: 'Hrs Available for Booking', field: 'hrs_available_for_booking' },
    { title: 'Applied Date', field: 'applied_date' },
    { title: 'Approval Date', field: 'approval_date' },
    { title: 'Booked Hours', field: 'booked_hours' },
    { title: 'Truncated Hours', field: 'truncated_hours' },
    { title: 'Location', field: 'location' },
    { title: 'Booking Status', field: 'booking_status' },
    { title: 'Manager Review Status', field: 'Manager_Review_Status' },
    { title: 'Reviewed By Number', field: 'Review_By_Number' },
    { title: 'Reviewed By Name', field: 'Review_By_Name' },
    { title: 'Status', field: 'status' }
  ];

  const exportToExcel = async () => {
    setLoading(true);

    try {
      const payload = {
        role: selectedRole || availableRoles.join(","),
        pers_no: sanitizeNumeric(auth.personNumber),
      };
      const response = await apiService.budgetExceededReport(payload, dispatch);
      if (response?.status === 403) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Unauthorized access",
        });
        return;
      }

      const responseData = response?.data;

      if (
        responseData?.msg === "Success" &&
        Array.isArray(responseData?.data) &&
        responseData.data.length > 0
      ) {
        const exportData = responseData.data.map(({ id, ...rest }) => {
          const reorderedItem = {};
          baseDefaultColumns.forEach(({ title, field }) => {
            reorderedItem[title] = rest[field] ?? "";
          });
          return reorderedItem;
        });

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        XLSX.writeFile(workbook, "Budget_Exceeded_Report.xlsx");
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Data Not Found",
        });
      }
    } catch (error) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",
      });
    } finally {
      setLoading(false);
    }
  };



  const renderOther = () => (
    <div>
      <Grid
        container
        spacing={2}
        direction="column"
        className={styles.myGrid}
      >
        {/* 🔹 RADIO BUTTON ROW (Only if more than one role) */}
        {availableRoles.length > 1 && (
          <Grid item xs={12}>
            <RadioGroup
              row
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              {availableRoles.includes("SA") && (
                <FormControlLabel
                  value="SA"
                  control={<Radio size="small" color="primary"/>}
                  label="Super Admin"
                  className={styles.radiobtn}
                />
              )}

              {availableRoles.includes("DS") && (
                <FormControlLabel
                  value="DS"
                  control={<Radio size="small" color="primary"/>}
                  label="Departmental SPOC"
                  className={styles.radiobtn}
                />
              )}

              {availableRoles.includes("LI") && (
                <FormControlLabel
                  value="LI"
                  control={<Radio size="small" color="primary" />}
                  label="Project Linkage"
                  className={styles.radiobtn}
                />
              )}
            </RadioGroup>
          </Grid>
        )}

        {/* 🔹 EXPORT BUTTON ROW (CENTER ALIGNED) */}
        <Grid item xs={12} style={{ textAlign: "center" }} alignItems="center">
          <p>
            <strong>Budget Exceeded Report Download Here:</strong>
          </p>

          {/* <Button
          className={clsx(styles.actionButton)}
          variant="contained"
          color="success"
          data-testid="confirm-action"
          onClick={exportToExcel}
          startIcon={<SiMicrosoftexcel />}
        >
          Export Report
        </Button> */}
          <Button className={clsx(styles.actionButton)} variant="primary" data-testid="confirm-action" onClick={() => exportToExcel()}  disabled={disableExport} startIcon={<SiMicrosoftexcel />} style={{ marginLeft: "12px" }} > Export Report </Button>
        </Grid>
      </Grid>
    </div>

  );


  return (
    <>

      <div className={styles.formContainer}>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Budget Report" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>

        </div>
        <CustomFormGroup header='Budget Exceeded Report' body={renderOther()} />
        {
          loading ? (
            <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "40px" }}>
              <Truckloading />
            </div>) : ""
        }

      </div>
    </>
  );
};

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});

BudgetExceededReport.propTypes = {
  redirectToProcessPage: PropTypes.func,
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(BudgetExceededReport);

export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);

